function createToastElement(message, details) {
  const toast = document.createElement("div");
  toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 15px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    z-index: 9999;
    max-width: 300px;
  `;

  const messageEl = document.createElement("div");
  messageEl.style.cssText =
    "font-size: 16px; margin-bottom: 5px; font-weight: bold; color: #dc3545;";
  messageEl.textContent = message;
  toast.appendChild(messageEl);

  if (details) {
    const detailsEl = document.createElement("div");
    detailsEl.style.cssText = "font-size: 14px; color: #666;";
    detailsEl.textContent = details;
    toast.appendChild(detailsEl);
  }

  return toast;
}

export function showToast(message, details) {
  const toast = createToastElement(message, details);
  document.body.appendChild(toast);

  // Remove the toast after 5 seconds
  setTimeout(() => {
    if (toast && document.body.contains(toast)) {
      document.body.removeChild(toast);
    }
  }, 5000);
}
